module.exports = __webpack_public_path__ + "static/feature7-70968aaa9cba4fc95a4822969efbba24.png";